/**
 * The mortgage-programme posters, as the live site shows them: fifteen images and no text.
 *
 * **They are pictures of programmes, not the programmes themselves.** The calculator's fourteen keys
 * and their effective-dated rates live in the API and are staff-only; these are marketing artwork
 * whose numbers were true on the day somebody exported them. Nothing here is read by anything that
 * calculates, and nothing that calculates is rendered here — keeping the two apart is what stops a
 * poster from reading as a quote.
 */
export const programSlides: readonly string[] = Array.from(
    { length: 15 },
    (_, index) => `/media/images/mortgage-programs/${index + 1}.jpeg`
);
